import { observer } from 'mobx-react-lite'
import { useRef } from 'react'
import classNames from 'classnames'
import { checkCDN } from 'shared/lib/checkCDN'
import { useMediaController } from 'widgets/PresentationMode/hooks/useMediaController'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import styles from './styles.module.scss'

export const PresentationVideo = observer(() => {
  const ref = useRef<HTMLVideoElement>(null)
  const presentationStore = usePresentationModeContext()
  const { currentAttachment, setDisabledOverlayClick, videoControllerStore } = presentationStore
  const { mediaControllerStore, isFull } = videoControllerStore

  const { onMouseEnter, onMouseLeave, handelEnded, onLoadedData } = useMediaController({
    mediaControllerStore,
    ref,
    setDisabledOverlayClick,
  })
  const url = currentAttachment?.source || currentAttachment?.source_short || ''

  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={classNames(styles.wrap, isFull && styles.isFull)}
    >
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video
        onLoadedData={onLoadedData}
        onEnded={handelEnded}
        src={url}
        ref={ref}
        {...(checkCDN(url) ? { crossOrigin: 'use-credentials' } : null)}
      />
    </div>
  )
})
